// extracted by mini-css-extract-plugin
module.exports = {"si-wrapper":"OwnListingLink_si-wrapper__1UJmY","silc-btn":"OwnListingLink_silc-btn__1psGp","defaultLinkStyle":"OwnListingLink_defaultLinkStyle__1heCH"};